import $ from 'jQuery';
import utility from 'libraries/utility';

function classWithEventsParams()
{
}

var fp = classWithEventsParams.prototype;
fp.events = {
};

fp.parameters = {
  events: fp.events
};

fp.init = function(parameters)
{
  this.parameters = this.mergePrototypeProperty('parameters');
  if(typeof(parameters) === 'object' && parameters)
    this.parameters = utility.deepMerge(this.parameters, parameters);
};

fp.mergePrototypeProperty = function(propertyName, prototype, mergedProperty)
{
  if(typeof(prototype) === 'undefined')
    prototype = this.__proto__;

  if(!mergedProperty)
    mergedProperty = new Object();

  if(prototype)
  {
    if(typeof(prototype[propertyName]) === 'object')
      mergedProperty = utility.deepMerge(prototype[propertyName], mergedProperty);

    if(typeof(prototype.__proto__) === 'object')
      mergedProperty = this.mergePrototypeProperty(propertyName, prototype.__proto__, mergedProperty);
  }

  return mergedProperty;
};

fp.runCallbacks = function(eventName, callbackParameters, callbackFunction)
{
  if(typeof this.parameters.events === 'object' && typeof this.parameters.events[eventName] === 'object')
    for(let callback of this.parameters.events[eventName])
      callback(callbackParameters);

  if(typeof(callbackFunction) === 'function')
    callbackFunction(callbackParameters);
};

export default classWithEventsParams;



// WEBPACK FOOTER //
// ./vendor/kuvio-framework/kuvio-framework/applications/adminFrontend/scripts/libraries/classWithEventsParams.js